import {UPDATE_AUTH, UPDATE_USER, LOGOUT} from '../types'

export const updateAuth = (payload) => ({type: UPDATE_AUTH, payload})
export const updateUser = (payload) => ({type: UPDATE_USER, payload})
export const logout = () => ({type: LOGOUT})
